import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import LoadingSpinner from '../../ui/LoadingSpinner';

const StripeCardForm = ({ cardKey, showCardElement, onCardChange, onCardReady, disabled }) => {
  return (
    <div className={`mb-6 ${disabled ? 'opacity-50' : ''}`}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Card Information
      </label>
      <div className="border border-gray-300 rounded-md p-3">
        {showCardElement ? (
        <CardElement 
            key={cardKey}
            id="card-element"
            options={{
              style: {
                base: {
                  fontSize: '16px',
                  color: '#424770',
                  '::placeholder': {
                    color: '#aab7c4',
                  },
                },
                invalid: {
                  color: '#9e2146',
                  iconColor: '#9e2146',
                },
              },
            }}
            onChange={onCardChange}
            onReady={onCardReady}
        />
        ) : (
          <div className="py-2 text-center text-gray-500">
            <LoadingSpinner size="small" />
            <span className="ml-2">Loading payment form...</span>
          </div>
        )}
      </div>
      <p className="text-xs text-gray-500 mt-1">
        Secured by Stripe. We do not store your card details.
      </p>
    </div>
  );
};

export default StripeCardForm; 